export const authEventTypes = [
  'login.success',
  'login.failed',
  'login.locked',
  'lockout.triggered',
  'register.success',
  'register.failed',
  'logout',
  'logout.all',
  'device.new',
  'device.removed',
  'password.changed',
  'refresh.success',
  'refresh.replay_detected',
  'refresh.expired',
  'user.role_changed',
] as const;
